import React, { Fragment, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  DateFilter,
  ShipmentFilters,
  ShipperFilter,
  MunicipalityFilter,
  RouteFilter,
  AlertsFilter,
  VehicleTypeFilter,
  BusinessFilter,
  FTBFilter,
} from 'components/ShipmentFilters';

import {
  jobsMounted,
  jobsUnmounted,
  fetchMoreJourneys,
  visibilityChange,
} from 'redux/modules/journeys/effects';

import JourneyMap from 'modules/journey/map/Modal';

import { filterJobs } from 'redux/modules/jobs/effects';

import { getUnassignedFilters } from 'redux/modules/jobs/selectors';

import { UnassignedJourneyList } from 'modules/journey/list';
import JobSelector from './JobSelector';
import { constants, getClientConfig } from 'redux/modules/client-config/selectors';

const Unassigned = ({ history, parentRoutes }) => {
  const { location } = history;

  const state = location.state || {};

  const { fromDetail = false } = state;

  const { action } = history;

  const filters = useSelector(getUnassignedFilters);

  const dispatch = useDispatch();

  const handleFetchMore = useCallback(
    (params) => {
      dispatch(fetchMoreJourneys(params));
    },
    [dispatch]
  );

  const handleVisibilityChange = useCallback(() => {
    dispatch(visibilityChange(!document.hidden, filters));
  }, [dispatch, filters]);

  const onChangeFilter = useCallback(
    (params) => {
      dispatch(filterJobs(params, { section: 'UNASSIGNED' }));
    },
    [dispatch]
  );

  useEffect(() => {
    const triggerFetch = !fromDetail || action === 'POP';
    dispatch(jobsMounted());
    dispatch(filterJobs(filters, { triggerFetch, realtime: true, section: 'UNASSIGNED' }));
    return () => {
      dispatch(jobsUnmounted());
    };
    //eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);

  const FILTERS = useSelector((state) => getClientConfig(state, constants.FILTERS));

  return (
    <Fragment>
      <ShipmentFilters
        status={filters}
        onChangeFilter={onChangeFilter}
        rows={[
          [
            <JobSelector routes={parentRoutes} />,
            <DateFilter showCalendar={false} grow />,
            FILTERS[constants.JOBS_FTB] ? <FTBFilter /> : <></>,
            FILTERS[constants.JOBS_BUSINESS] ? <BusinessFilter marginRight /> : <></>,
            <ShipperFilter />,
          ],
          [
            <AlertsFilter />,
            <RouteFilter />,
            FILTERS[constants.JOBS_MUNICIPALITY] ? <MunicipalityFilter grow /> : <></>,
            FILTERS[constants.JOBS_VEHICLE_TYPE] ? <VehicleTypeFilter /> : <></>,
          ],
        ]}
      />
      <JourneyMap />
      <UnassignedJourneyList onLoadMore={handleFetchMore} />
    </Fragment>
  );
};

export default Unassigned;
